import { render, staticRenderFns } from "./allocation.vue?vue&type=template&id=5bfe2088&scoped=true&"
import script from "./allocation.vue?vue&type=script&lang=js&"
export * from "./allocation.vue?vue&type=script&lang=js&"
import style0 from "./allocation.vue?vue&type=style&index=0&id=5bfe2088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe2088",
  null
  
)

export default component.exports